import {Component, EventEmitter, Output} from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {BaseUtil} from "../../../../shared/utils/base.util";
import {complaintStatuses, contactMotives} from "../../../../shared/types/custom-types";
import {ComplaintStatus} from "../../../../shared/enums/status.enum";
import {FeedbackFilterRequestModel} from "../../../../shared/model/request/feedback-filter-request.model";

@Component({
    selector: 'app-feedback-filters',
    templateUrl: './feedback-filters.component.html',
    standalone: false
})
export class FeedbackFiltersComponent {

  form: FormGroup;

  @Output('submitFilter') submitEmitter = new EventEmitter<FeedbackFilterRequestModel>()

  readonly motives: { code: string, description: string }[] = contactMotives()

  statuses = BaseUtil.removeFromStatus(complaintStatuses())
  maxDate: Date = new Date();

  constructor() {
  }

  ngOnInit(): void {
    this.form = new FormGroup<any>({
      "name": new FormControl(null),
      "email": new FormControl(null),
      "type": new FormControl(null),
      "status": new FormControl(ComplaintStatus.PENDING),
      "creationDate": new FormControl(null),
    })
    this.onSubmit()
  }

  onClear() {
    this.form.reset()
    this.form.get('status').setValue(ComplaintStatus.PENDING)
    this.onSubmit();
  }

  onSubmit() {
    this.submitEmitter.emit(this.form.value)
  }
}
